import React from 'react';
import LabelToggle from "../../components/labelToggle";
import FormGroup from "../../components/formGroup";
import MyFile from "../../components/myFile";

function Bourse(props) {
    const infoBourse = (
        <>
            <FormGroup label={"Numéro de la demande"}
                       defaultValue={props.BourseNumBourse}
                       onBlur={(e) => props.onChange(e.target.value)}
                       name={"BourseNumBourse"}/>

            <MyFile label={"Accusé de réception"}
                    name={"BourseFichierID"}
                    filename={props.filename}
                    onChange={(id, name) => props.onChange(id, name)}
            />
        </>
    );

    return (
        <div>
            <LabelToggle name={"HasBourse"}
                         label={"Avez-vous introduit une demande de bourse pour la nouvelle année académique, celle dans laquelle vous êtes actuellement occupé de faire votre réinscription ?"}
                         onChange={props.onChange.bind(this)}
                         checked={props.checked}/>
            {props.checked && infoBourse}
        </div>
    );
}

export default Bourse;